import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-productionSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			new Swiper (el.querySelector('.b-productionSlider-container'), {
				slidesPerView: 'auto',
				spaceBetween: 10,
				slideClass: 'b-productionSlider-item',
				loop: false,
				watchOverflow: true,
				navigation : {
					nextEl : el.querySelector('.b-productionSlider-btn_next'),
					prevEl : el.querySelector('.b-productionSlider-btn_prev'),
				},
				breakpoints: {
					768: {
						spaceBetween: 20,
					},
				},
			});
		});
	});
});
